<template>
  <div class="time-range flex-grow-1">
    <div class="d-flex k-time-range d-flex flex-grow-1 time-range">
      <div class="range-start-time multiple px-1 font-size-16">
        <div :class="cssTimeRange" class="start-time">
          <div class="text-size-12 text-left">Start time</div>
          <v-select
            ref="start"
            :options="startTimeOptions"
            :appendToBody="false"
            :clearable="true"
            :searchable="false"
            placeholder="Start"
            :reduce="(title) => title.code"
            :value="startTime"
            @input="setStartTime"
            @open="onFocus"
            @close="onBlurr"
            label="title"
          ></v-select>
        </div>
      </div>
      <div class="range-end-time multiple px-1">
        <div :class="cssTimeRange" class="end-time">
          <div class="text-size-12 text-left">End time</div>
          <v-select
            ref="end"
            :options="endTimeOptions()"
            :appendToBody="false"
            :clearable="true"
            :searchable="false"
            placeholder="Start"
            :reduce="(title) => title.code"
            :value="endTime"
            @input="setEndTime"
            label="title"
          ></v-select>
        </div>
      </div>
      <div v-if="choiceSpecificLimit" class="range-limit multiple px-1">
        <div class="signup-limit">
          <div class="text-size-12 text-left">
            {{ $t('options.signupLimit') }}
          </div>
          <v-select
            ref="limit"
            :options="rangeLimitOptions"
            :appendToBody="false"
            :clearable="true"
            :searchable="false"
            :value="limit"
            @input="setLimit"
            :reduce="(title) => title.code"
            label="title"
          ></v-select>
        </div>
      </div>
    </div>
    <div class="d-flex row-range-text">
      <div class="range-text">
        <div class="text-size-12 text-left">Free text</div>
        <div class="">
          <div class="">
            <div class="p-l2">
              <input
                type="text"
                class="form-control2"
                v-bind:value="range.comment"
                v-on:input="onTextChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import vSelect from "vue-select";
import { mapState } from 'vuex';

function hasTime(d) {
  let date = new Date(d);
  if (date.getHours() != 0) return true;
  if (date.getMinutes() != 0) return true;
  if (date.getSeconds() != 0) return true;
  return false;
}

function getTime(d) {
  let date = new Date(d);

  let hours = date.getHours();
  hours = ('0' + hours).slice(-2);
  let minutes = date.getMinutes();
  minutes = ('0' + minutes).slice(-2);
  return hours + ':' + minutes;
}

//import Autocomplete from 'vuejs-auto-complete';
//import { ModelSelect } from 'vue-search-select';
//import SelectField from '@/components/UI/SelectField';
import vSelect from 'vue-select';

export default {
  name: 'TimeRange',
  props: {
    date: {
      type: Date,
      required: true,
    },
    range: {
      type: Object,
      required: true,
    },
  },

  data: function () {
    return {
      selectingStartTime: true,
      startTime: null,
      endTime: null,
      signupLimit: null,
      startSearching: false,
      endSearching: false,
      duration: null,
      limit: 'no limit',
    };
  },

  components: {
    // Autocomplete,
    //ModelSelect,
    //SelectField,
    vSelect,
  },

  watch: {
    range: {
      deep: true,
      handler(newVal, oldVal) {
        console.log('Range changed: ', newVal, ' | was: ', oldVal);
        if (!newVal) {
          return;
        }
        console.log('updateOnRangeChnage');
        this.onRangeChnage(newVal);
      },
    },
  },
  methods: {
    isSpecificChoiceLimitEnabled() {
      return this.poll.options.limitedVotesPerChoiceSpecific;
    },
    onFocus() {
      console.log('OnFocus');
      //this.$emit('focus');
    },

    onBlurr() {
      console.log('onBlurr');
      this.$emit('blurr');
    },
    startSelected(value) {
      console.log('startSelected:', value);
      this.startTime = value;
    },
    onStartResults() {
      console.log('onStartResults');
      if (this.startSearching) return;
      this.startSearching = true;
      console.log('onResults: before clear:', this.range.start);
      this.$refs.start.clear();
      console.log('onResults:after clear:', this.range.start);
      this.$refs.start.search();
    },

    onEndResults() {
      console.log('onEndResults');
      if (this.endSearching) return;
      console.log('onEndResults - endsearching true');
      this.endSearching = true;
      console.log('onResults: clear');
      this.$refs.end.clear();
      this.$refs.end.search();
      this.endSearching = false;
    },

    onNoResults() {
      console.log('onNoResults');
    },

    onTextChange(event) {
      console.log('onTextChange');
      this.range.comment = event.target.value;
      let range = this.range;

      if (range.start == null) range.start = range.date;

      console.log('onTextChnage range:', range);
      this.$emit('update', this.range);
    },

    onRangeChnage(range) {
      if (range.start == null) {
        return;
      }
      const dayEvent = this.range.start == this.range.end;

      //console.info('onRangeChnage:', range, this.endTime);

      this.limit = range.limit;
      let startDate = new Date(range.start);
      if (hasTime(range.start)) {
        this.startTime = this.getTimeOfDay(startDate);
      } else {
        this.startTime = null;
      }

      if (range.end == null) {
        this.endTime = null;
        return;
      }
      if (!dayEvent) {
        let endDate = new Date(range.end);
        this.endTime = this.getTimeOfDay(endDate);
      }
    },

    setStartTime(value) {
      let tap = this.$refs.start.typeAheadPointer;
      //console.log('setStartTime:', value, this.duration, tap);
      this.startTime = value;
      this.$nextTick(() => {
        this.$refs.start.typeAheadPointer = tap;
      });
      let start = new Date(this.date.getTime() + value * 60000);
      let range = this.range;
      range.start = start;

      if (value) {
        if (!this.duration) {
          this.duration = this.defaultDuration;
        }
        this.endTime = this.startTime + this.duration;
        range.end = new Date(this.date.getTime() + this.endTime * 60000);
      } else {
        range.end = null;
        this.endTime = null;
      }

      console.log('setStartTime range:', value, range, this.duration);
      this.$emit('updateRange', range);
    },

    clearStartDate() {
      let range = this.range;
      if (range.start) {
        let date = new Date(range.start);
        date.setHours(0, 0, 0, 0);
        range.start = date;
      }
      range.end = null;
      this.startTime = null;
      this.endTime = null;
      console.log('(clearStartDate) - Update rage with:', range);
      //this.$emit('updateRange', range);
    },

    setLimit(value) {
      //console.info('setLimit', value);
      this.limit = value;
      let range = this.range;

      range.limit = value;
      this.$emit('updateRange', range);
    },
    setEndTime(value) {
      let tap = this.$refs.end.typeAheadPointer;
      console.log('setEndTime:', value, this.duration);
      this.endTime = value;

      let end = new Date(this.date.getTime() + value * 60000);
      let range = this.range;
      range.end = end;

      if (value) {
        this.duration =
          (new Date(range.end).getTime() - new Date(range.start).getTime()) /
          (60 * 1000);

        this.$store.commit('updateDuration', this.duration);
      }
      this.$nextTick(() => {
        this.$refs.end.typeAheadPointer = tap;
      });

      tap = this.$refs.end.typeAheadPointer;
      console.log('setEndTime2:', tap);
      this.$emit('updateRange', range);
    },

    clearEndDate() {
      let range = this.range;
      range.end = null;
      this.$emit('updateRange', range);
    },

    // focusStartTime() {
    //   console.log('focus!');
    //   this.startTime = this.startTimeOptions[5];
    // },

    // selectStartTime(e) {
    //   console.log('start time was selected');
    //   console.log(e.currentTarget.getAttribute('data-minutes'));
    // },
    // clickStartTime() {
    //   console.log('start time was clicked');
    // },

    pad(number, length) {
      var str = '' + number;
      while (str.length < length) {
        str = '0' + str;
      }
      return str;
    },

    getTimeOfDay(date) {
      let h = this.pad(date.getHours(), 2);
      let m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      return h + ':' + m;
    },

    convertMinsToHrsMins(mins) {
      let h = Math.floor(mins / 60);
      let m = mins % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return `${h}:${m}`;
    },

    convertDurationToHrsMins(mins) {
      let h = Math.floor(mins / 60);
      let m = mins % 60;
      if (h == 0) {
        return `${m} Min.`;
      }
      if (m == 0) {
        return `${h} St.`;
      }
      return `${h}S.:${m}M. `;
    },

    endTimeOptions() {
      let list = [];

      if (!this.endTime) {
        let item = {};
        item.code = null;
        item.title = 'Ende';
        list.push(item);
      }

      if (!hasTime(this.range.start)) {
        console.log('no start time found');
        this.$nextTick(() => {
          this.$refs.end.typeAheadPointer = 0;
        });

        return list;
      }

      // let start = getTime(this.range.start);
      let startDate = new Date(this.range.start);
      let start = startDate.getHours() * 60 + startDate.getMinutes();
      let end = 24 * 60;
      console.log('end options for start time:', start);
      for (var i = start + 15; i < end; i += 15) {
        let item = {};
        item.code = i;
        item.title = this.convertMinsToHrsMins(i);
        // item.name += ' (' + this.convertDurationToHrsMins(i - start) + ')';
        list.push(item);
      }

      const index = list.findIndex((o) => o.title == this.endTime);
      this.$nextTick(() => {
        this.$refs.end.typeAheadPointer = index;
        //console.log('set typeAheadPointer:', list, this.endTime, index);
      });

      return list;
    },
  },

  mounted() {
    const dayEvent = this.range.start == this.range.end;
    if (this.range.limit == 0) this.range.limit = null;
    console.log('TimeRange mounted:', this.range);
    this.limit = this.range.limit;
    if (this.range.start && hasTime(this.range.start)) {
      let start = new Date(this.range.start);
      this.startTime = this.getTimeOfDay(start);

      const index = this.startTimeOptions.findIndex(
        (o) => o.title == this.startTime
      );

      this.$nextTick(() => {
        this.$refs.start.typeAheadPointer = index;
      });

      console.log('start time set to:', this.startTime, index);
    } else {
      this.$nextTick(() => {
        this.$refs.start.typeAheadPointer = 33;
      });
    }
    //console.info('mounted endTime:', this.endTime);

    if (!dayEvent && this.range.end) {
      let start = new Date(this.range.start);
      if (this.range.end) {
        let end = new Date(this.range.end);
        this.duration = (end - start) / 60000;
        this.endTime = this.getTimeOfDay(end);
      }
    }
    //console.info('mounted endTime:', this.endTime);
  },

  computed: {
    ...mapState({
      defaultDuration: (state) => state.poll.defaultDuration,
      poll: (state) => state.poll.poll,
    }),

    choiceSpecificLimit() {
      return this.poll.options.limitedVotesPerChoiceSpecific;
    },

    cssTimeRange() {
      if (this.choiceSpecificLimit) {
        return 'time-range-with-limit';
      }
      return 'time-range-no-limit';
    },

    noLimitLabel() {
      if (this.choiceSpecificLimit) {
        return 'no limit';
      }
      return 'Premium only';
    },

    rangeLimitOptions() {
      let list = [];
      list.push({ code: null, title: this.noLimitLabel });
      for (let i = 1; i <= 100; i++) {
        list.push({ code: i, title: `${i}` });
      }
      console.log('rangeLimitOptions', list);
      return list;
    },

    initialSartTime() {
      if (this.range.start && hasTime(this.range.start)) {
        return getTime(this.range.start);
      }
      return null;
    },

    initialEndTime() {
      if (this.range.end && hasTime(this.range.end)) {
        return getTime(this.range.end);
      }
      return null;
    },

    endTimeDisabled() {
      return false;
    },

    disabled() {
      if (!this.startTime) {
        return true;
      }
      return false;
    },

    startTimeOptions() {
      let list = [];

      if (!this.startTime) {
        let item = {};
        item.code = null;
        item.title = 'Start';
        list.push(item);
      }
      let start = 0;
      let end = 24 * 60;

      for (var i = start; i < end; i += 15) {
        let item = {};
        item.code = i;
        item.title = this.convertMinsToHrsMins(i);

        list.push(item);
      }

      // start = 0;
      // end = 480;
      // for (i = start; i < end; i += 15) {
      //   let item = {};
      //   item.id = i;
      //   item.name = this.convertMinsToHrsMins(i);
      //   list.push(item);
      // }

      return list;
    },

    startTimeOptions2() {
      let list = [];

      if (!this.startTime && !this.selectingStartTime) {
        let item = {};
        item.value = 0;
        item.label = 'Startzeit';
        list.push(item);
        return list;
      }
      let start = 480;
      let end = 24 * 60;

      for (var i = start; i < end; i += 15) {
        let item = {};
        item.id = i;
        item.name = this.convertMinsToHrsMins(i);

        list.push(item);
      }

      start = 0;
      end = 480;
      for (i = start; i < end; i += 15) {
        let item = {};
        item.id = i;
        item.name = this.convertMinsToHrsMins(i);
        list.push(item);
      }

      return list;
    },
  },
};

import '@/styles/select-variables.scss';
//import 'vue-select/src/scss/vue-select.scss';
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/style.scss';
$vs-dropdown-min-width: 80px !important;
$vs-dropdown-z-index: 30002 !important;
$vs-dropdown-max-height: 150px !important;
@import 'vue-select/src/scss/vue-select.scss';

.start-time,
.end-time {
}

.time-range-no-limit {
}

.time-range-with-limit {
}

.signup-limit {
  width: 95px;
}

.range-start-time,
.range-end-time {
  width: 100%;
}

.range-text {
  width: 463px;
}

.range-text {
  .form-control {
    font-size: 16px;
    padding: 0px 6px;
  }
}

.time-range {
  font-size: 16px;
  display: flex;
  flex-direction: column;
}

.vs__search {
  padding: 0;
  width: 1px;
}

.vs__open-indicator {
  display: none;
}

.vs__clear {
  margin-right: 0px !important;
}

.autocomplete__icon.autocomplete--clear {
  display: block;
  width: 16px;
}

.autocomplete__icon {
  display: none;
}

.autocomplete__box {
}

.autocomplete__box:focus-within {
  background-color: #eeeeee;
  border-radius: 5px;
}

.autocomplete {
}

.autocomplete__inputs {
  .form-control {
    font-size: 0.7rem;
    padding: 0px 0px;
  }

  input.form-control:focus {
    box-shadow: 0 0px 0px rgba(0, 0, 0, 0.075) inset,
      0 0 0px rgba(126, 239, 104, 0.6);
    outline: 0 none;
    border-color: rgba(126, 239, 104, 0.8);
    border: 0px solid;
    border-radius: 0px;
    background-color: transparent;
  }
}

.autocomplete__results {
  display: block;
  max-height: 200px !important;
}

.autocomplete__results__item {
  text-align: left;
  display: block;
}

.autocomplete__box {
  flex-grow: 1;
}

.multiple {
  input {
    margin-top: 5px;
  }

  input:first-of-type {
    margin-top: 0px;
  }
}

.v-select {
  margin-top: 5px;
  background-color: $white;
}

.k-time-range {
  margin-top: 10px;
  margin-bottom: 10px;
  flex-direction: row;
}

.ui.dropdown .menu > .item {
  font-size: 16px !important;
}

.ui.dropdown input {
  font-size: 16px !important;
}

.time-range {
  background-color: $very-light-grey;
  margin-bottom: 10px;
}

.form-control2 {
  display: block;
  width: 100%;
  // height: calc(1.5em + 0.75rem + 2px);
  padding: 3px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.row-range-text {
  //background-color: aqua;
  flex-direction: column;
  padding-bottom: 6px;
}

.range-text {
  //background-color: red;
  width: 100%;
  padding-left: 6px;
  padding-right: 4px;
}

.flex-grow {
  flex: 1 0 auto;
}
@media screen and (max-width: 480px) {
  .autocomplete__results__item {
    font-size: $standard;
  }
  .autocomplete__inputs {
    .form-control {
      font-size: $standard;
    }
  }
}
</style>
